import { useEffect, useMemo, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { TOOL_LINKS } from '../../content/tools'
import { cn } from '../../lib/cn'
import { ROUTES } from '../../lib/routes'

export default function Header() {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const navItems = useMemo(() => TOOL_LINKS.slice(0, 4), [])

  return (
    <header
      className={cn(
        'sticky top-0 z-50 border-b border-white/10 bg-slate-950/70 backdrop-blur transition',
        scrolled && 'bg-slate-950/90',
      )}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link
          to={ROUTES.home}
          className="group flex items-center gap-2 font-semibold tracking-tight text-white"
          aria-label="Inicio de PDF Rápido"
        >
          <span className="grid size-9 place-items-center rounded-xl bg-gradient-to-br from-sky-400/20 to-indigo-500/20 ring-1 ring-white/10 transition group-hover:ring-white/20">
            <span className="text-sm">PDF</span>
          </span>
          <span className="hidden sm:inline">Rápido</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="Navegación principal">
          {navItems.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              className={({ isActive }) =>
                cn(
                  'rounded-lg px-3 py-2 text-sm text-slate-200 transition hover:bg-white/5 hover:text-white',
                  isActive && 'bg-white/10 text-white',
                )
              }
            >
              {item.shortLabel}
            </NavLink>
          ))}
          <NavLink
            to={ROUTES.tools}
            className={({ isActive }) =>
              cn(
                'rounded-lg px-3 py-2 text-sm text-slate-200 transition hover:bg-white/5 hover:text-white',
                isActive && 'bg-white/10 text-white',
              )
            }
          >
            Herramientas
          </NavLink>
          <NavLink
            to={ROUTES.about}
            className={({ isActive }) =>
              cn(
                'rounded-lg px-3 py-2 text-sm text-slate-200 transition hover:bg-white/5 hover:text-white',
                isActive && 'bg-white/10 text-white',
              )
            }
          >
            Acerca de
          </NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to={ROUTES.home + '#tools'}
            className="rounded-xl bg-gradient-to-r from-sky-400 to-indigo-500 px-3 py-2 text-sm font-semibold text-slate-950 shadow-sm shadow-sky-500/20 transition hover:opacity-90"
          >
            Elegir herramienta
          </Link>
        </div>
      </div>
    </header>
  )
}

